<template>
  <div class="not-found">
    <title-bar
      :needBack="true"
      title="404"
    ></title-bar>
    <rich-result-page
      type="lost"
    ></rich-result-page>
  </div>
</template>

<script type="text/ecmascript-6">
import TitleBar from '@/components/TitleBar'
export default {
  name: 'NotFound',
  components: {
    TitleBar
  }
}
</script>

<style scoped>
  .not-found {
    height: 100%;
  }
</style>
